module.exports = __webpack_public_path__ + "static/img/logo_.b09d7679.png";